import { Landplot } from "../organisation/Landplot";
import { ContractPhoto, buildContractPhoto } from "./ContractPhoto";

export class Harvest {
    constructor(land_plot?: Landplot,
        quantity?: number,
        photos?: ContractPhoto[],
        fruit_pile_uri?: string,
        fruit_bunch_uri?: string,
        pickedUp?: number[],) {
        this.land_plot = land_plot
        this.quantity = quantity
        this.photos = photos
        this.fruit_pile_uri = fruit_pile_uri
        this.fruit_bunch_uri = fruit_bunch_uri
        this.pickedUpPosition = pickedUp
    }


    fruitPhotos(): ContractPhoto[]|undefined {
        return this.photos?.filter(p => p.isFruit())
    }

    land_plot?: Landplot
    quantity?: number
    photos?: ContractPhoto[]
    fruit_pile_uri?: string
    fruit_bunch_uri?: string
    pickedUpPosition?: number[]

    static build(h: any): Harvest {
        return new Harvest(h.land_plot ? Landplot.build(h.land_plot) : undefined,
            h.quantity ?? h.loaded_quantity,
            h.photos?.map((p:any) => buildContractPhoto(p.photo ?? p)),
            h.fruit_pile_uri,
            h.fruit_bunch_uri,
            h.location?.coordinates)
    }
}